import { createSlice } from '@reduxjs/toolkit'
import api from '../../Core/Services/Api'
import { ofType } from 'redux-observable'
import { from } from 'rxjs'
import { mergeMap } from 'rxjs/operators'
import { manageEpicResponse } from '../../Common/Utils/Api'
import { apiSlice } from '../../Common/Utils/Redux'

// reducer
const packagesSlice = createSlice(apiSlice('packages', { value: [] }))

export const { request, success, failure } = packagesSlice.actions

export default packagesSlice.reducer

export const selectPackages = (state) => state.packages
export const selectPackagesData = (state) => state.packages.data.value
export const selectPackagesFetched = (state) => state.packages.fetched
export const selectPackagesFetching = (state) => state.packages.fetching

// side effects
export const fetchPackagesEpic = (action$) =>
  action$.pipe(
    ofType('packages/request'),
    mergeMap(() =>
      from(api.packages.get()).pipe(
        ...manageEpicResponse(
          success,
          failure,
          'core:errors.FetchPackagesError',
        ),
      ),
    ),
  )
